import { useRouter, defineNuxtPlugin } from '#app'
import { useLenisStore } from '~/stores/lenisStore'

export default defineNuxtPlugin(() => {
  const lenisStore = useLenisStore()
  const router = useRouter()

  router.afterEach((to) => {
    if (!to.hash) {
      lenisStore.scrollTo(0)
      return
    }

    let attempts = 0

    const interval = setInterval(() => {
      const element = document.getElementById(to.hash.replace('#', ''))

      if (element || attempts >= 5) {
        clearInterval(interval)

        if (element) {
          element.scrollIntoView()
        }
      }

      attempts++
    }, 1000)
  })
})
